module.exports = __webpack_public_path__ + "static/media/home-button.777aade6.svg";